import React from 'react'
import SterilizationInfoPanel from '../../../../components/material/DeviceDashboard/SterilizationInfo/SterilizationInfoPanel'
import { useDispatch, useSelector } from 'react-redux';
import { fetchCycleEvents, setCurrentPressureUnit } from '../deviceDashboardSlice';

const SterilizationInfoContainer = () => {
    const dispatch = useDispatch();
    const {
        cycleEvents,
        cycleMetadata,
        selectedCycle,
        currentPressureUnit,
        deviceSerial,
        userTimezone,
        deviceTimezone,
        weightUnit,
    } = useSelector(
        // @ts-ignore
        (store) => store.devicedashboard
    );

    // @ts-ignore
    const loading = useSelector((store) => store.devicedashboard.loading.sterilizationInfo);

    const setPressureUnit = (pressureUnit) => {
        // @ts-ignore
        dispatch(setCurrentPressureUnit(pressureUnit));
    }

    const fetchEvents = () => {
        // @ts-ignore
        dispatch(fetchCycleEvents(selectedCycle.id));
    }

    return (
        <SterilizationInfoPanel
            cycleEvents={cycleEvents}
            cycleMetadata={cycleMetadata}
            selectedCycle={selectedCycle}
            currentPressureUnit={currentPressureUnit}
            deviceSerial={deviceSerial}
            userTimezone={userTimezone}
            deviceTimezone={deviceTimezone}
            weightUnit={weightUnit}
            loading={loading}
            setPressureUnit={setPressureUnit}
            fetchCycleEvents={fetchEvents}
        />
    )
}

export default SterilizationInfoContainer
